import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from 'react-router-dom';
import { StoreProvider } from './store/store';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Brand, isAdeed } from './constants/brand';
import { applyThemeMode } from './common/theme-mode/theme-mode';

// ADEED Freight, before the first render: <html data-brand="adeed"> (the ADEED palette and font in src/index.css),
// light or dark (Settings > Appearance) so dark never flashes light, and the page head. public/index.html is
// TruKKer's, so the tab title, icons, theme colour, manifest and the Space Grotesk font are swapped here; link
// previews and crawlers that don't run scripts see TruKKer's head on both hosts.
if (isAdeed) {
  document.documentElement.dataset.brand = "adeed";
  applyThemeMode();
  applyAdeedHead();
}

function applyAdeedHead() {
  const head = document.head;
  const publicUrl = process.env.PUBLIC_URL;
  const favicon = `${publicUrl}/brand/adeed-favicon.png`;
  const addLink = (attrs) => {
    const link = document.createElement("link");
    Object.entries(attrs).forEach(([name, value]) => link.setAttribute(name, value));
    head.appendChild(link);
    return link;
  };

  document.title = Brand.appName;
  head.querySelectorAll('link[rel~="icon"]').forEach((link) => link.remove());
  addLink({ rel: "icon", type: "image/png", sizes: "32x32", href: favicon });
  head.querySelectorAll('link[rel="apple-touch-icon"]').forEach((link) => link.setAttribute("href", favicon));
  head.querySelector('meta[name="theme-color"]')?.setAttribute("content", "#0A0F1E");
  head.querySelector('link[rel="manifest"]')?.setAttribute("href", `${publicUrl}/manifest-adeed.json`);
  head.querySelector('link[rel="canonical"]')?.remove(); // it names loadboard.trukker.com
  // Space Grotesk, loaded the way the ADEED portal loads it (src/index.css holds the bold/semibold aliases)
  addLink({ rel: "preconnect", href: "https://fonts.googleapis.com" });
  addLink({ rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: "" });
  addLink({ rel: "stylesheet", href: "https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&display=swap" });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StoreProvider>
    {/* <HashRouter> */}
      {/* <App /> */}
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
    >
      <App />
    </GoogleReCaptchaProvider>


    {/* </HashRouter> */}
  </StoreProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
